export default __webpack_public_path__ + "static/media/icebox.65109902.png";